import type { CoinbaseEngUsersAccountManagementApiApiWorkspaceAuditEvent } from '@cbhq/identity-api-hooks/account-management/types';

import type { AuditLogRowEntry } from '../types';

import { ACTIVITY_DATE_FILTER_OPTIONS } from './constants';

export function mapAuditEventToRow(
  event: CoinbaseEngUsersAccountManagementApiApiWorkspaceAuditEvent,
): AuditLogRowEntry {
  return {
    actor: {
      id: event.actor?.id ?? '',
      name: event.actor?.name || null,
      email: event.actor?.email || null,
      avatar_url: event.actor?.avatarUrl ?? '',
    },
    target: {
      id: event.target?.id ?? '',
      name: event.target?.name || null,
      email: event.target?.email || null,
      avatar_url: event.target?.avatarUrl ?? '',
    },
    event_type: event.eventType ?? '',
    timestamp: event.timestamp ?? '',
    actor_context: {
      country_code: event.actorContext?.countryCode ?? '',
      ip_address: event.actorContext?.ipAddress ?? '',
      user_agent: event.actorContext?.userAgent ?? '',
      city: event.actorContext?.city ?? '',
    },
    event_id: event.eventId ?? '',
    legal_entity_id: event.legalEntityId ?? '',
    legal_entity_name: event.legalEntityName ?? '',
    outcome: event.outcome ?? '',
    correlation_id: event.correlationId ?? '',
  };
}

export function getStartTimeFromDatePreset(dateFilter: string | null): string {
  if (!dateFilter) {
    return '';
  }

  const preset = ACTIVITY_DATE_FILTER_OPTIONS.find((option) => option.value === dateFilter);
  if (!preset) {
    return '';
  }

  return new Date(Date.now() - preset.hoursAgo * 60 * 60 * 1000).toISOString();
}

export function truncateEventId(eventId: string): string {
  if (!eventId || eventId.length <= 1) {
    return eventId;
  }

  const halfLength = Math.ceil(eventId.length / 2);
  return `${eventId.slice(0, halfLength)}…`;
}
